import { Component, inject, signal } from '@angular/core';
import { NotificationService } from '@services/notification.service';
import { Notification as  Notif } from '@models/common.model';

@Component({
  selector: 'lgb-notification',
  standalone: false,
  templateUrl: './notification.html',
  styleUrl: './notification.css',
})
export class Notification {
  readonly notifService=inject(NotificationService);
  readonly notifs=signal<Notif[]>([]);

  constructor(){
    this.notifService.notify
      .subscribe(notif => this.notifs().push(notif));
  }

  getClass(notif: Notif){
    return {
      'alert-info': notif.type=='info',
      'alert-success': notif.type=='success',
      'alert-error': notif.type=='error',
    }
  }
}
